<template>
  <section id="video-page" class="lms-container" :key="componentKey">
    <component :is="styleTest" v-if="showAnnotation">
      <hsc-window
        title="Anotações"
        style="z-index:999999;margin:0px"
        :isScrollable="true"
        :resizable="true"
        :minWidth="200"
        :minHeight="200"
      >
        <editor-menu-bar :editor="editor">
           <!-- v-slot="{ commands, isActive }">
          <div class="menubar"> -->
            <!-- <button
              class="menubar__button"
              :class="{ 'is-active': isActive.editorHighlight() }"
              @click="commands.editorHighlight()"
            >
              <i class="material-icons">highlight</i>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.bold() }"
              @click="commands.bold"
            >
              <i style="color:black;" class="material-icons">format_bold</i>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.italic() }"
              @click="commands.italic"
            >
              <i style="color:black;" class="material-icons">format_italic</i>
            </button> -->

            <!-- <button
              class="menubar__button"
              :class="{ 'is-active': isActive.strike() }"
              @click="commands.strike"
            >
              <i class="material-icons">format_strikethrough</i>
            </button> -->

            <!-- <button
              class="menubar__button"
              :class="{ 'is-active': isActive.underline() }"
              @click="commands.underline"
            >
              <i class="material-icons">format_underlined</i>
            </button> -->

            <!-- <button
              class="menubar__button"
              :class="{ 'is-active': isActive.bullet_list() }"
              @click="commands.bullet_list"
            >
              <i class="material-icons">insert_link</i>
            </button>
            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 1 }) }"
              @click="commands.heading({ level: 1 })"
            >H1</button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 2 }) }"
              @click="commands.heading({ level: 2 })"
            >H2</button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 3 }) }"
              @click="commands.heading({ level: 3 })"
            >H3</button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.ordered_list() }"
              @click="commands.ordered_list"
            >
              <i class="material-icons">format_list_bulleted</i>
            </button>

            <button
              class="menubar__button"
              :class="{ 'is-active': isActive.blockquote() }"
              @click="commands.blockquote"
            >
              <i class="material-icons">format_quote</i>
            </button> -->

            <!-- <button class="menubar__button" @click="commands.undo">
              <i class="material-icons">undo</i>
            </button>

            <button class="menubar__button" @click="commands.redo">
              <i class="material-icons">redo</i>
            </button>
          </div> -->
        </editor-menu-bar>
        <editor-content :editor="editor" />
      </hsc-window>
    </component>

    <modal-vue v-if="showModal" @close="showModal = false">
      <h3 slot="header">Upload de Arquivo</h3>

      <div slot="body">
        <div class="modules-content" style="overflow-y: scroll;padding-right:0px;padding-left:0px;">
          <div class="module-item">
            <ul class="lessons-list">
              <li class="lesson-subtitle custom-grid-modal">
                <span class="lesson-title">Adicione o arquivo</span>
              </li>

              <li class="lesson custom-grid-modal">
                <div class="large-12 medium-12 small-12 cell">
                  <input type="file" id="files" ref="files" v-on:change="handleFilesUpload()" />
                </div>
                <div class="large-12 medium-12 small-12 cell">
                  <div v-for="(file, key)  in files" :key="file.name" class="file-listing">
                    {{ file.name }}
                    <button
                      @click="removeFile( key )"
                      :disabled="uploadingFiles == true"
                      class="btn btn-success"
                    >
                      Remover Arquivo
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
                <br />
              </li>
            </ul>
            <div class="large-12 medium-12 small-12 cell">
              <button
                @click="submitFiles()"
                :disabled="files.length < 1 || uploadingFiles == true"
                class="btn btn-success"
              >
                Carregar para o servidor
                <i class="fa fa-upload"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer">
        <button class="btn btn-default" @click="showModal = false">Fechar</button>
      </div>
    </modal-vue>

    <modal-vue v-if="showFeedbackModal" @close="showFeedbackModal = false">
      <h3 slot="header">Análise das respostas</h3>

      <div slot="body">
        <div class="modules-content" style="overflow-y: scroll;padding-right:0px;padding-left:0px;">
          <div class="module-item">
            <div class="large-12 medium-12 small-12 cell" v-if="feedBackAnswers.length > 0">
              <div v-for="item in feedBackAnswers" :key="item.id" class="file-listing">
                <span>Nome do arquivo enviado: {{ item.alias }}</span>
                <br />
                <span>Clique para baixar o arquivo enviado:</span>
                <a v-bind:href="item.url" target="_blank" style="font-size: 14px;">{{item.alias}}</a>
                <br />
                <span
                  style="font-weight: bold;"
                >O professor considerou sua questão: {{ item.isCorrect ? 'Correta' : 'Incorreta' }}</span>
                <br />
                <br />
              </div>
            </div>
            <div v-else>
              <span>Você não enviou nenhum arquivo ou o professor ainda não realizou a correção</span>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer">
        <button class="btn btn-default" @click="showFeedbackModal = false">Fechar</button>
      </div>
    </modal-vue>

    <modal-vue v-if="showAnswersModal" @close="showAnswersModal = false">
      <div slot="header" class="row">
        <h3>Corrigindo: &nbsp; {{selectedExercise.alias}}</h3>
      </div>

      <div slot="body" style="margin:0px;" v-if="lessonExerciseAnswer.length > 0">
        <div class="exam-question" style="display: block;">
          <div class="exam-anwser-options" v-if="lessonExerciseAnswer.length > 0">
            <span>Clique para baixar o arquivo:</span>
            <a
              v-bind:href="lessonExerciseAnswer[answerIndex].url"
              target="_blank"
              style="font-size: 14px;"
            >{{lessonExerciseAnswer[answerIndex].alias}}</a>
            <br />
            <br />
            <br />
          </div>
          <div v-else>
            <span>Esse exercício não possui material pendente de correção</span>
            <br />
            <br />
            <br />
          </div>

          <div slot="footer" v-if="lessonExerciseAnswer.length > 0">
            <lms-button @click="previousAnswer()">Resposta Anterior</lms-button>
            <lms-button
              style="margin-left: 50px !important;"
              :disabled="!(lessonExerciseAnswer.length - 1 > answerIndex)"
              @click="nextAnswer()"
            >Próxima Resposta</lms-button>
            <br />
            <br />
            <button @click="checkAnswer(false)" :disabled="loading" class="btn btn-danger">
              Marcar como ERRADA
              <i class="fa fa-warning"></i>
            </button>
            <button
              style="margin-left: 50px !important;"
              @click="checkAnswer(true)"
              class="btn btn-success"
              :disabled="loading"
            >
              Marcar como CERTA
              <i class="fa fa-check"></i>
            </button>
          </div>

          <!-- PEGAR A LISTA DE ANSWERS QUE TEM ISCORRECT NULL E IDUSER, QUE SEJAM DESDE QUIZ -->
        </div>
      </div>
      <div v-else slot="body" style="margin:0px;">
        <span>Não há itens pendetes de correção</span>
      </div>

      <div slot="footer">
        <button style="float: left;" class="btn btn-danger" v-on:click="close()">Fechar</button>
      </div>
    </modal-vue>

    <div class="content">
      <div class="breadcrumb" style="border: none !important;"></div>

      <new-question
        @closeModal="showNewQuestion=false;"
        v-if="showNewQuestion"
        :videoId="currentVideo.id"
      ></new-question>
      <new-ticket @closeModal="showNewTicket=false;" v-if="showNewTicket"></new-ticket>

      <div class="content-player">
        <div class="video-content">
          <video-player
            v-if="currentVideo && currentVideo.id"
            :videoId="currentVideo.id"
            @updateTime="logVideoTime"
          ></video-player>

          <div class="video-description-content">
            <h5 style="font-size: 17px;">{{lesson.title}} - Professor(a): {{lesson.teacherName}}</h5>

            <div class="annotation-options">
              <button
                v-if="!showAnnotation"
                @click="showAnnotation=true"
                id="disabled-annotation-mode"
              >Modo de Anotações</button>
              <button
                v-else
                @click="showAnnotation=false"
                id="active-annotation-mode"
              >Sair do modo anotação</button>
            </div>

            <ul>
              <li
                v-if="currentVideo"
                v-bind:class="{ 'lesson-button-disabled': currentVideo.order == 0 }"
                style="position: relative;"
              >
                <a @click="previousVideo" style="font-size: 12px;">
                  <i class="icon icon-circle-left-38"></i>
                  <div class="module-description-tooltip">Vídeo anterior</div>
                </a>
              </li>

              <li
                v-if="currentVideo"
                v-bind:class="{ 'lesson-button-disabled': currentVideo.order == videos.length-1 }"
                style="position: relative;"
              >
                <a @click="nextVideo" id="proximo" style="font-size: 12px;">
                  <i class="icon icon-circle-right-37"></i>
                  <div class="module-description-tooltip">Próximo video</div>
                </a>
              </li>

              <li class="btn-bug-button">
                <icon-button
                  id="video-bug-button"
                  :text="'Fale com a Secretaria'"
                  :loading="showNewTicket"
                  @click="showNewTicket = true;"
                >
                  <i class="icon icon-settings"></i>
                </icon-button>
              </li>

              <li class="btn-bug-button">
                <icon-button
                  id="video-bug-button"
                  :text="'Fale com o professor'"
                  :loading="showNewQuestion"
                  @click="showNewQuestion = true;"
                >
                  <i class="fa fa-question"></i>
                </icon-button>
              </li>
            </ul>
          </div>

          <!-- <div class="video-description-content">
            <h5>Vídeo: {{lesson.title}} - Professor(a): {{lesson.teacherName}}</h5>

            <div class="annotation-options">
              <lms-button :loading="showNewQuestion" @click="showNewQuestion = true;">Nova dúvida</lms-button>
            </div>
          </div>-->

          <!-- <div class="video-alternative-content">
            <button
              id="video-bug-button"
              data-toggle="modal"
              data-target="#video_problem_modal"
            >Problema no vídeo?</button>
          </div>-->
        </div>

        <div class="all-videos-group">
          <a href="#material-ancora" class="btn-ancora" style="font-size: 14px;">
            <div class="ancora-material-isolado">
              <i class="icon icon-single-copy-04"></i>
              Materiais da aula
            </div>
          </a>
          <a href="#material-exercicio" class="btn-ancora" style="font-size: 14px;">
            <div class="ancora-material-isolado">
              <i class="icon icon-single-copy-04"></i>
              Exercícios Complementares
            </div>
          </a>
          <a href="#material-link" class="btn-ancora" style="font-size: 14px;">
            <div class="ancora-material-isolado">
              <i class="icon icon-single-copy-04"></i>
              Links Externos
            </div>
          </a>
          <ul>
            <li v-for="v in videos" :key="v.id">
              <a v-on:click="loadVideo(v)" href="#" style="font-size: 13px;">
                <img :src="v.thumbPath" />
                <div class="text-content">
                  <span class="video-title">{{v.title}}</span>
                  <span v-if="v.id == currentVideo.id" class="video-status">Você está nesse vídeo</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <a id="material-ancora"></a>
      <div class="row" >
        <div id="lesson_attachments">
          <div class="title-section-content">
            <h3 class="text-center" style="font-size: 24px;">Materiais da aula</h3>
          </div>

          <ul>
            <li v-for="item in coursewares" :key="item.id">
              <a v-bind:href="item.url" target="_blank" style="font-size: 14px;">{{item.alias}}</a>
              <button
                v-on:click="deleteCoursewareById(item.id)"
                v-if="userType == 0 || userType ==2"
              >Remover Material</button>
            </li>
          </ul>
        </div>
      </div>

      <a id="material-exercicio"></a>
      <div class="row" id="material-exercicio">
        <div id="lesson_attachments">
          <div class="title-section-content">
            <h3 class="text-center" style="font-size: 24px;">Exercícios Complementares</h3>
          </div>
          <ul>
            <li v-for="item in lessonExercise" :key="item.id">
             <a v-bind:href="item.url" target="_blank" style="font-size: 14px;"><span style="color: #4ebcd7; font-weight: bold; !important;" v-if="item.newest == true">NOVO!</span> {{item.alias}}  </a>

              <lms-button @click="showModal = true, selectedExercise = item">Responder Exercício</lms-button>

              <lms-button
                style="margin-left: 45px !important"
                @click="selectedExercise = item, getExerciseFeedback(item.id)"
              >Visualizar Feedback</lms-button>
              <br />
              <button v-on:click="deleteExerciseById(item.id)"  v-if="userType == 0 || userType ==2">Remover Exercício</button>
              <button style="margin-left: 40px !important"
                v-on:click="getExerciseAnswer(item.id), selectedExercise = item"
                v-if="userType == 0 || userType ==2"
              >Visualizar Respostas do Alunos</button>
            </li>
          </ul>
        </div>
      </div>

      <a id="material-link"></a>
      <div class="row" >
        <div id="lesson_attachments">
          <div class="title-section-content">
            <h3 class="text-center" style="font-size: 24px;">Links Externos</h3>
          </div>
          <ul>
            <li v-for="item in lessonLinks" :key="item.id">
             <a v-bind:href="item.url" target="_blank" style="font-size: 14px;"><span style="color: #4ebcd7; font-weight: bold; !important;" v-if="item.newest == true">NOVO!</span> {{(item.urlDescription ? item.urlDescription : item.url)}}  </a>
              <button v-on:click="deleteLinkById(item.id)"  v-if="userType == 0 || userType ==2">Remover Link</button>
            </li>
          </ul>
        </div>
      </div>

      <!-- <s:if test="!'EXTRA_ACTIVITY'.equals(lesson.type)">

			<div class="annotation-content">
			    <div id="editor-status"></div>
			    <div id="toolbar-container"></div>
			    <div id="editor">
			        <s:property escapeHtml="false" value="annotation.content" />
			    </div>
			</div>

      </s:if>-->
    </div>
  </section>
</template>

<style lang="scss" scoped>
.lesson-button-disabled {
  opacity: 0.5;
}
.body-blue {
  color: blue;
}
.body-red {
  color: red;
}
</style>

<script>
import axios from "axios";
axios.defaults.withCredentials = true;
import router from "../../../router";
import VideoPlayer from "../VideoPlayer";
import NewQuestion from "./NewQuestion";
import NewTicket from "../Support/NewTicket";
import { StyleFactory } from "@hscmap/vue-window";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
// import { Editor, EditorContent, EditorMenuBar } from "@tiptap/vue-2";
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from "tiptap-extensions";
import EditorHighlight from "./EditorHighlight";

export default {
  data() {
    return {
      styleTest: StyleFactory({
        button: {
          color: "red"
        },
        buttonActive: {
          color: "white"
        },
        buttonHover: {
          backgroundColor: "rgba(255, 0, 0, 0.8)"
        },
        content: {
          margin: "0px",
          backgroundColor: "rgba(255, 255, 255,0.8)"
        },
        titlebar: {
          color: "#fff",
          background: "rgb(0, 0, 0)"
        },
        window: {
          border: "1px solid #f00",
          color: "rgb(51,51,51)",
          boxShadow: "0 2pt 8pt rgba(0, 0, 0, 0.5)"
        }
      }),
      annotationJson: {},
      needSave: false,
      timeCount: new Date(),
      showAnnotation: false,
      editor: null,
      showNewQuestion: false,
      showNewTicket: false,
      videos: [],
      currentVideo: {},
      componentKey: 0,
      lessons: [],
      coursewares: [],
      lessonExercise: [],
      lessonExerciseAnswer: [],
      lesson: this.$store.getters.lesson,
      module: this.$store.getters.module,
      previous: null,
      nextLesson: {},
      next: null,
      isAdmin: false,
      broadcast: false,
      klass: {},
      message: "",
      showMessage: false,
      thumbPath: "",
      userType: this.$store.getters.user.type,
      selectedExercise: null,
      showModal: false,
      files: [],
      uploadingFiles: false,
      showAnswersModal: false,
      answerIndex: 0,
      loading: false,
      showFeedbackModal: false,
      feedBackAnswers: [],
      lessonLinks: []
    };
  },

  components: {
    EditorContent,
    EditorMenuBar,
    NewTicket,
    "new-question": NewQuestion,
    "video-player": VideoPlayer
  },
  methods: {
    nextAnswer() {
      console.log("proxima resposta");
      console.log(this.answerIndex);
      console.log(this.lessonExerciseAnswer);
      if (this.lessonExerciseAnswer.length - 1 > this.answerIndex) {
        this.answerIndex = this.answerIndex + 1;
      }
    },
    previousAnswer() {

      console.log(this.answerIndex);
      if (this.answerIndex > 0) {
        this.answerIndex -= 1;
        console.log(this.answerIndex);
      }
    },
    saveAnnotation() {

      var endTime = new Date();
      var timeDiff = endTime - this.timeCount; //in ms
      timeDiff /= 100;
      var seconds = Math.round(timeDiff);

      if (seconds > 1) {
        this.needSave = false;
        this.timeCount = new Date();

        const path = this.$global.endpoint + "/video/annotation/save";
        axios
          .post(path, {
            videoId: this.currentVideo.id,
            content: this.annotationJson
          })
          .then(res => {})
          .catch(error => {
            console.error(error);
          });
      } else {
        this.needSave = true;
      }
    },
    logVideoTime(percentage) {
      let finishedAt = null;
      if (percentage == 100) finishedAt = new Date();
      const path = this.$global.endpoint + "/video/saveprogress";
      axios
        .post(path, {
          videoId: this.currentVideo.id,
          percentage: percentage,
          finishedAt: finishedAt
        })
        .then(res => {})
        .catch(error => {
          console.error(error);
        });
    },
    newQuestion() {},
    loadVideo(video) {
      this.currentVideo = video;
      this.componentKey += 1;
      this.getAnnotation();
      //this.$router.push({ name: 'lesson'});
      //this.$router.push({ name: 'lesson', params: {lesson_id: lesson_id }})
    },
    close() {
      this.showAnswersModal = false;
    },
    downloadItem(item) {
      let a = document.createElement("a");
      a.href = item.url;
      a.download = item.alias;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    loadCourseware() {
      let apiCall = "/courseware/getall";
      const path = this.$global.endpoint + apiCall;
      axios
        .post(path, {
          lessonId: this.lesson.id
        })
        .then(res => {
          this.coursewares = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    loadExercise() {
      console.log("vai buscar o exercicio com o id:" + this.lesson.id);
      let apiCall = "/lesson/getexercise";
      const path = this.$global.endpoint + apiCall;
      axios
        .post(path, {
          lessonId: this.lesson.id
        })
        .then(res => {
          this.lessonExercise = res.data;

          if(this.lessonExercise.length > 0){
              this.lessonExercise[0].newest = true;
          }

          console.log("exercicios: " + JSON.stringify(this.lessonExercise));
        })
        .catch(error => {
          console.error(error);
        });
    },
    loadLinks() {
      let apiCall = "/links/getall";
      const path = this.$global.endpoint + apiCall;
      axios
        .post(path, {
          lessonId: this.lesson.id
        })
        .then(res => {
          res.data.forEach((el, index, array) => {
            res.data[index].url = (res.data[index].url.startsWith('http://') || res.data[index].url.startsWith('https://') ? res.data[index].url : 'http://' + res.data[index].url );

          });
          this.lessonLinks = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getExerciseAnswer(id) {
      console.log("vai buscar o exercicio com o id:" + id);
      let apiCall = "/lesson/getexerciseAnswer";
      const path = this.$global.endpoint + apiCall;
      axios
        .post(path, {
          lessonExerciseId: id
        })
        .then(res => {
          this.lessonExerciseAnswer = res.data;
          this.showAnswersModal = true;
          console.log(
            "respostas dos exercicios: " +
              JSON.stringify(this.lessonExerciseAnswer)
          );
        })
        .catch(error => {
          console.error(error);
        });
    },
    getExerciseFeedback(id) {
      console.log("vai o feedback do exercicio com o id:" + id);
      let apiCall = "/lesson/getexerciseanswerfeedback";
      const path = this.$global.endpoint + apiCall;
      axios
        .post(path, {
          lessonExerciseId: id
        })
        .then(res => {
          this.feedBackAnswers = res.data;
          this.showFeedbackModal = true;
          console.log(
            "feedback dos exercicios: " + JSON.stringify(this.feedBackAnswers)
          );
        })
        .catch(error => {
          console.error(error);
        });
    },
    deleteCoursewareById(id) {
      let apiCall = "/courseware/delete";
      const path = this.$global.endpoint + apiCall;
      axios
        .post(path, {
          id: id
        })
        .then(res => {
          this.loadCourseware();
        })
        .catch(error => {
          console.error(error);
        });
    },
    deleteExerciseById(id) {
      let apiCall = "/lesson/deleteexercise";
      const path = this.$global.endpoint + apiCall;
      axios
        .post(path, {
          id: id
        })
        .then(res => {
          this.loadExercise();
        })
        .catch(error => {
          console.error(error);
        });
    },
    deleteLinkById(id) {
      let apiCall = "/links/delete";
      const path = this.$global.endpoint + apiCall;
      axios
        .post(path, {
          id: id
        })
        .then(res => {
          this.loadLinks();
        })
        .catch(error => {
          console.error(error);
        });
    },
    getVideos() {
      console.log(this.lesson);
      const path = this.$global.endpoint + "/video/getall";
      axios
        .post(path, {
          lessonId: this.lesson.id
        })
        .then(res => {
          this.videos = res.data;
          this.getCurrentVideo();
        })
        .catch(error => {
          console.error(error);
        });
    },
    checkAnswer(answer) {
      this.loading = true;
      this.lessonExerciseAnswer[this.answerIndex].isCorrect = answer;
      console.log(this.lessonExerciseAnswer);
      console.log(
        "vou checar a questão: " +
          this.lessonExerciseAnswer[this.answerIndex].id
      );
      //SALVAR NO BANCO no then pegar as respostas novamente

      const path = this.$global.endpoint + "/lesson/updateexerciseanswer";
      axios
        .post(path, {
          lessonExerciseAnswerId: this.lessonExerciseAnswer[this.answerIndex]
            .id,
          isCorrect: answer
        })
        .then(res => {
          console.log(res.data);
          this.getExerciseAnswer(this.selectedExercise.id);
          this.loading = false;
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    },
    getCurrentVideo() {
      if (this.lesson.lastVideoId) {
        for (let i = 0; i < this.videos.length; i++) {
          if (this.videos[i].id == this.lesson.lastVideoId) {
            console.log(this.videos[i]);
            this.currentVideo = this.videos[i];
          }
        }
      }

      if (!this.lesson.lastVideoId || !this.currentVideo.id) {
        this.currentVideo = this.videos[0];
      }
      this.getAnnotation();
    },
    getAnnotation() {
      this.annotationJson = {};
      if(this.editor){
        this.editor.destroy();
      }
      const path = this.$global.endpoint + "/video/annotation/get";
      axios
        .post(path, {
          videoId: this.currentVideo.id
        })
        .then(res => {
          this.editor = new Editor({
            extensions: [
              // new Blockquote(),
              // new BulletList(),
              // new CodeBlock(),
              // new HardBreak(),
              // new Heading({ levels: [1, 2, 3] }),
              // new HorizontalRule(),
              // new ListItem(),
              // new OrderedList(),
              // new TodoItem(),
              // new TodoList(),
              // new Link(),
              // new Bold(),
              // new Code(),
              // new Italic(),
              // new Strike(),
              // new Underline(),
              // new History(),
              // new EditorHighlight()
            ],
            onUpdate: ({ getHTML, getJSON }) => {
              this.annotationJson = getJSON();
              this.saveAnnotation();
            }
            // ,
            // content: `
            //    <br><br><br><br><br><br><br>
              //  `
          });


          this.annotationJson = JSON.parse(res.data.content);


          for(let i = this.annotationJson.content.length; i < 5; i++){
            this.annotationJson.content.push({type: "paragraph"});
            console.log("annotation", i)
          }
          console.log("this.annotationJson", this.annotationJson.content.length)

          this.editor.setContent(this.annotationJson);
        })
        .catch(error => {
          console.error(error);
        });
    },
    nextVideo() {
      for (let i = 0; i < this.videos.length; i++) {
        if (this.videos[i].order == this.currentVideo.order + 1) {
          this.currentVideo = this.videos[i];
          this.componentKey += 1;
          break;
        }
      }
      this.getAnnotation();
    },
    previousVideo() {
      for (let i = 0; i < this.videos.length; i++) {
        if (this.videos[i].order == this.currentVideo.order - 1) {
          this.currentVideo = this.videos[i];
          this.componentKey += 1;
          break;
        }
      }
      this.getAnnotation();
    },
    addFiles() {
      this.$refs.files.click();
    },
    submitFiles() {
      console.log("deu submit do exercicio");
      console.log(this.uploadingFiles);
      this.uploadingFiles = true;

      let formData = new FormData();

      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        formData.append("files[" + i + "]", file);
      }

      formData.append("idLessonExercise", this.selectedExercise.id);

      let endpointUpload = "";

      const path = this.$global.endpoint + "/upload/upload-exerciseanswer";
      axios
        .post(path, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function() {
          console.log("SUCCESS!!");
          alert("Arquivo compartilhado com sucesso");
          this.uploadingFiles = false;
          this.files = [];
          this.showModal = false;
        })
        .catch(function() {
          console.log("FAILURE!!");
          this.uploadingFiles = false;
        });
    },
    handleFilesUpload() {
      let uploadedFiles = this.$refs.files.files;

      this.files = []; //just one file

      this.uploadingFiles = false;

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
    },
    removeFile(key) {
      this.files.splice(key, 1);
      this.files = [];
    },
    updatePresence(){

      const path = this.$global.endpoint + "/presence/set";

      axios
        .post(path, {
          userId: this.$store.getters.user.id,
          courseId: this.module.course_id
        }).then(function(response) {
          console.log("presence", response.data);
        });

    }
  },
  created() {
    this.interval = setInterval(() => {
      if (this.needSave == true) {
        const path = this.$global.endpoint + "/video/annotation/save";
        axios
          .post(path, {
            videoId: this.currentVideo.id,
            content: this.annotationJson
          })
          .then(res => {
            this.needSave = false;
          })
          .catch(error => {
            console.error(error);
          });
      }
    }, 100);

    this.getVideos();
    this.loadCourseware();
    this.loadExercise();
    this.loadLinks();
  },
  mounted() {

    this.updatePresence();

    this.editor = new Editor({
      extensions: [
        // new Blockquote(),
        // new BulletList(),
        // new CodeBlock(),
        // new HardBreak(),
        // new Heading({ levels: [1, 2, 3] }),
        // new HorizontalRule(),
        // new ListItem(),
        // new OrderedList(),
        // new TodoItem(),
        // new TodoList(),
        // new Link(),
        // new Bold(),
        // new Code(),
        // new Italic(),
        // new Strike(),
        // new Underline(),
        // new History(),
        // new EditorHighlight()
      ],
      onUpdate: ({ getHTML, getJSON }) => {
        this.annotationJson = getJSON();
        this.saveAnnotation();
      }
      // ,
      // content: `
      //     <br><br><br><br><br><br><br>
      //     `
    });
  },
  beforeDestroy() {
    this.editor.destroy();
  }
};
</script>
